module.exports = __webpack_public_path__ + "img/40_38_061_880.6b2ad920.jpg";